<template>
  <div class="vote container">
    <div class="top">
      <div class="back_box">
        <!-- <img src="@/assets/images/icons/icon_back.png" alt="" /> -->
        <el-button
          class="back-btn"
          type="text"
          icon="el-icon-arrow-left"
          @click="$router.go(-1)"
          >返回</el-button
        >
      </div>
      <div class="info">
        <img class="icon" src="@/assets/images/icons/a_vote.png" alt="" />
        <div class="mid">
          <p class="title">{{ info.name }}</p>
          <p style="margin-top: 5px">
            <span class="time">{{
              formatDate(info.startTime, "MM-DD HH:mm")
            }}</span>
            <span class="shu">|</span>
            <span class="surplus" v-if="info.status == 'STARTED'"
              >剩余<i class="el-icon-time"></i>{{ surplus }}</span
            >
            <span class="end_tag" v-else>已结束</span>
          </p>
        </div>
        <span v-if="isDo" style="margin-left: 180px"
          >我选择了{{ myAnswer.answer }}</span
        >
        <el-button
          class="submit_btn"
          type="primary"
          round
          v-show="info.status == 'STARTED' && !isDo"
          @click="handleSubmit"
          >提交</el-button
        >
      </div>
    </div>
    <div class="main">
      <div class="vote_box" v-if="!isDo && info.status == 'STARTED'">
        <div
          class="btn"
          :class="{ active: params.answer == item }"
          v-for="item in option"
          :key="item"
          @click="params.answer = item"
        >
          {{ item }}
        </div>
      </div>
      <template v-else-if="info.lookStatistics">
        <div class="row" v-for="item in newArr" :key="item.label">
          <p>{{ item.label }}</p>
          <el-progress
            :stroke-width="10"
            :percentage="
              parseInt(item.list.length / doList.length * 100) || 0
            "
            :format="(percentage) => format(percentage, item.list.length)"
          ></el-progress>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { vote, voteInfo, voteList } from "@/api/activity/vote";
import { activityInfo } from "@/api/activity";
import { dateCount } from "@/utils/index";
import { formatDate } from "@/utils/index";
export default {
  name: "vote",
  data() {
    return {
      formatDate,
      info: {},
      surplus: "",
      params: {
        activityId: this.$route.query.activityId,
        answer: null,
      },
      isDo: false,
      option: [],
      list: [],
      doList: [],
      notList: [],
      newArr: [],
    };
  },
  created() {
    this.getInfo();
  },
  beforeDestroy() {
    clearInterval(this.timerId);
  },
  methods: {
    // 活动信息
    getInfo() {
      let activityId = this.$route.query.activityId;
      activityInfo(activityId).then((res) => {
        if (res.code == 0) {
          this.info = res.data;
          // if (this.info.voteType == "RIGHT_ERROR")
          //   this.info.voteType = "正确_错误";
          // else if (this.info.voteType == "AGREE_OPPOSE")
          //   this.info.voteType = "赞同_反对";
          // this.option = res.data.voteType.split("_");
          this.option = JSON.parse(res.data.voteOptions)
          let end = new Date(this.info.startTime).getTime();
          let duration = this.info.duration * 60 * 1000;
          end = end + duration;
          let nowTime = +new Date();
          let times = (end - nowTime) / 1000;
          if (times > 0) {
            this.surplus = dateCount(times);
            this.timerId && clearInterval(this.timerId);
            this.timerId = setInterval(() => {
              if (times <= 0  && this.timerId) {
                clearInterval(this.timerId);
                this.getInfo();
              }
              this.surplus = dateCount(times);
              times--;
            }, 1000);
          }
        } else {
          console.log(res.msg);
        }
      });

      voteInfo(activityId).then((res) => {
        if (res.code == 0) {
          this.isDo = !!res.data;
          this.myAnswer = res.data;
          if (this.isDo) this.getVoteList();
        } else {
          console.log(res.msg);
        }
      });
    },
    // 投票
    handleSubmit() {
      vote(this.params).then((res) => {
        if (res.code == 0) {
          this.$message.success("投票成功");
          this.getInfo();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getVoteList() {
      voteList({ activityId: this.$route.query.activityId }).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.doList = res.data.filter((item) => {
            return item.answer;
          });
          this.notList = res.data.filter((item) => {
            return !item.answer;
          });

          // let options = this.info.voteType.split("_");
          // let arr = [];
          // options.forEach((item) => {
          //   let one = this.doList.filter((t) => {
          //     return t.answer == item;
          //   });
          //   arr.push(one);
          // });
          // this.newArr = options.map((label, idx) => ({
          //   label,
          //   list: arr[idx],
          // }));
        } else {
          console.log(res.msg);
        }
      });
    },
    format(percentage, num) {
      return `${num}人 ${parseInt(num / this.doList.length * 100) || 0}%`;
    },
  },
};
</script>

<style lang="less" scoped>
.vote {
  height: 100%;
  .top {
    margin-top: 30px;
    margin-bottom: 20px;
    width: 100%;
    text-align: left;
    .back_box {
      display: inline-block;
      width: calc(100% - 1126px);
      text-align: center;
      vertical-align: middle;
      cursor: pointer;
      img {
        width: 44px;
      }
      p {
        color: #969696;
        font-size: 16px;
      }
    }
    .info {
      position: relative;
      display: inline-block;
      padding: 24px 30px;
      background-color: #fff;
      width: 1126px;
      vertical-align: middle;
      .icon {
        width: 44px;
        height: 44px;
      }
      .mid {
        display: inline-block;
        margin-left: 20px;
        vertical-align: middle;
      }
      .title {
        font-size: 16px;
        color: #333;
      }
      .time {
        margin-top: 5px;
        color: #999;
        font-size: 14px;
      }

      .shu {
        padding: 0 10px;
        color: #ddd;
      }
      .el-icon-time {
        margin: 0 5px;
      }
      .surplus {
        color: sandybrown;
      }
      .end_tag {
        color: #c8c8c8;
      }
      .submit_btn {
        position: absolute;
        top: 50%;
        right: 30px;
        transform: translateY(-50%);
      }
    }
  }
  .main {
    position: relative;
    padding: 20px 60px;
    height: calc(100% - 30px - 20px - 88px - 30px);
    background-color: #fff;
    // text-align: left;
    overflow: auto;
    .vote_box {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .btn {
        margin-bottom: 30px;
        width: 160px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        font-size: 16px;
        color: #333;
        border: solid 1px #ddd;
        cursor: pointer;
        &.active {
          color: #ffffff;
          background: #1890ff;
          border-color: #1890ff;
        }
      }
    }
    ::v-deep .row {
      padding: 20px 0;
      width: 400px;
      text-align: left;
      p {
        margin-bottom: 15px;
      }
      .el-progress-bar {
        width: 90%;
      }
    }
  }
}
</style>